import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-collapsible" }

import CollapseControllerSummary from './CollapseControllerSummary.vue'
import { useI18n } from 'vue-i18n'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import { useButtonTextFormatter } from './composables'
import AccordionText from '@/design-system/atoms/AccordionText.vue'
import { LOCALES } from '@/utils/locales'
import { useCurrentFeatureFilters } from '@/composables/useFilters'

type Props = {
  isCollapsed: boolean
  showCalendar: boolean
}
type Emits = {
  (e: 'toggle-collapse')
  (e: 'present-calendar')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CollapseController',
  props: {
    isCollapsed: { type: Boolean },
    showCalendar: { type: Boolean }
  },
  emits: ["toggle-collapse", "present-calendar"],
  setup(__props: any) {

const { t, locale } = useI18n()

const filters = useCurrentFeatureFilters()
const { buttonText } = useButtonTextFormatter(LOCALES[locale.value])


const label = t('general__text__dashboard_change_filtering')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(CollapseControllerSummary, {
        showTimeSelection: false,
        fullscreen: false
      }),
      (
          _unref(filters) &&
          'calendar' in _unref(filters).current &&
          _unref(filters).current.calendar &&
          (_unref(filters).current.calendar.from ||
            _unref(filters).current.calendar.to ||
            _unref(filters).current.calendar.quickSelect)
        )
        ? (_openBlock(), _createBlock(ButtonOutline, {
            key: 0,
            id: "calendar-open-button",
            size: "small",
            "button-text": _unref(buttonText),
            style: 'white-space:nowrap; overflow:hidden; text-overflow:ellipsis',
            onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('present-calendar')))
          }, null, 8, ["button-text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(AccordionText, {
        id: "collapse-toggle-button",
        active: !_ctx.isCollapsed,
        size: 'small',
        accordionText: _unref(label),
        onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-collapse')))
      }, null, 8, ["active", "accordionText"])
    ])
  ]))
}
}

})